import {
  SET_SEARCH_TEMPLATES,
  SEARCH_TEMPLATEDRAFTS,
  SEARCH_TEMPLATEDRAFTS_SUCCESS,
  SEARCH_TEMPLATEDRAFTS_FAILED,
  SEARCH_TEMPLATES,
  SEARCH_TEMPLATES_SUCCESS,
  SEARCH_TEMPLATES_FAILED,
  SET_SORT_CRITERIAS,
  SET_EXAM_TYPES,
  FETCH_TEMPLATE_DETAILS,
  FETCH_TEMPLATE_DETAILS_SUCCESS,
  FETCH_TEMPLATE_DETAILS_FAILED,
  FETCH_LIVERANGETEMPLATE_DETAILS,
  FETCH_LIVERANGETEMPLATE_DETAILS_SUCCESS,
  FETCH_LIVERANGETEMPLATE_DETAILS_FAILED,
  FETCH_TEMPLATEDRAFT_DETAILS,
  FETCH_TEMPLATEDRAFT_DETAILS_SUCCESS,
  FETCH_TEMPLATEDRAFT_DETAILS_FAILED,
  SET_EDITED_EXAM,
  SET_ADDED_EXAM,
  REMOVE_TEMPLATES,
  REMOVE_TEMPLATES_SUCCESS,
  REMOVE_TEMPLATES_FAILED,
  REMOVE_TEMPLATEDRAFTS,
  REMOVE_TEMPLATEDRAFTS_SUCCESS,
  REMOVE_TEMPLATEDRAFTS_FAILED,
  RENAME_TEMPLATE_FAILED,
  RENAME_TEMPLATE_SUCCESS,
  RENAME_TEMPLATE,
  IMPORT_FILE,
  IMPORT_FILE_FAILED,
  IMPORT_FILE_SUCCESS,
  CLEAN_IMPORT_LAYOUT,
  UPDATE_VALIDATED_IMPORT,
  UPDATE_VALIDATED_IMPORT_SUCCESS,
  UPDATE_VALIDATED_IMPORT_FAILED,
  UNMAP_OFFICE,
  UNMAP_OFFICE_SUCCESS,
  UNMAP_OFFICE_FAILED,
  SET_CAN_ADD_EXAM,
  CLONE_TEMPLATE_DETAILS,
  CLONE_TEMPLATE_DETAILS_SUCCESS,
  RESET_CLONE_SUCCESS,
  SET_SELECTED_HOO,
  REMOVE_SLOT_FROM_SESSION,
  UPDATE_LIVE_RANGE0_TEMPLATE_SLOT_DETAILS,
  UPDATE_LIVE_RANGE0_TEMPLATE_SLOT_DETAILS_SUCCESS,
  UPDATE_LIVE_RANGE0_TEMPLATE_SLOT_DETAILS_FAILED,
  UPDATE_LIVE_SPECIALRANGE_TEMPLATE_SLOT_DETAILS,
  UPDATE_LIVE_SPECIALRANGE_TEMPLATE_SLOT_DETAILS_SUCCESS,
  UPDATE_LIVE_SPECIALRANGE_TEMPLATE_SLOT_DETAILS_FAILED,
  UPDATE_TEMPLATE_SLOT_DETAILS,
  UPDATE_TEMPLATE_SLOT_DETAILS_SUCCESS,
  UPDATE_TEMPLATEDRAFT_SLOT_DETAILS,
  UPDATE_TEMPLATEDRAFT_SLOT_DETAILS_SUCCESS,
  UPDATE_TEMPLATEDRAFT_SLOT_DETAILS_FAILED,
  CHECK_TEMPLATE_NAME_SUCCESS,
  CHECK_TEMPLATE_NAME_FAILED,
  RESET_TEMPLATE_NAME_VALID,
  CREATE_TEMPLATE_DETAILS_SUCCESS,
  CREATE_TEMPLATE_DETAILS,
  CREATE_TEMPLATE_DETAILS_FAILED,
  CREATE_TEMPLATEDRAFT_DETAILS_SUCCESS,
  CREATE_TEMPLATEDRAFT_DETAILS,
  CREATE_TEMPLATEDRAFT_DETAILS_FAILED,
  PUBLISH_DRAFT,
  PUBLISH_DRAFT_SUCCESS,
  PUBLISH_DRAFT_FAILED,
} from './templates-actions';

type TState = {
  templateNameValid: boolean | null;
  templates: {
    contents: [];
    pages: number;
    total: number;
  };
  search: {
    page: number;
    size: number;
    assigned: boolean;
    templateName?: string;
    drafts?: boolean;
    pace?: {
      from: number;
      to: number;
    };
    shiftLength?: {
      from: number;
      to: number;
    };
  };
  sorting: {};
  loading: boolean;
  error: any;
  templateDetails: any;
  detailsLoading: boolean;
  removeLoading: boolean;
  editedExam: any;
  addedExam: any;
  examTypes: any;
  importLoading: boolean;
  importFailed: boolean;
  importValidationData: any[];
  totalCount: any;
  successErrorReport: any;
  resourceFileUploadResponse: any;
  validationErrors: any[];
  canAddExam: false;
  toberemoved: any | null;
};

const initialState: TState = {
  templateNameValid: null,
  templates: {
    contents: [],
    pages: 0,
    total: 0,
  },
  search: {
    page: 0,
    size: 10,
    assigned: false,
    drafts: false,
  },
  sorting: {},
  loading: false,
  error: null,
  templateDetails: null,
  detailsLoading: false,
  removeLoading: false,
  editedExam: null,
  addedExam: null,
  examTypes: null,
  importLoading: false,
  importFailed: false,
  importValidationData: [],
  totalCount: null,
  successErrorReport: {},
  resourceFileUploadResponse: null,
  validationErrors: [],
  canAddExam: false,
  toberemoved: null,
};

export const templatesManagementReducer = (state = initialState, { type, payload, totalCount, validationErrors }) => {
  switch (type) {
    case CHECK_TEMPLATE_NAME_SUCCESS:
      return { ...state, templateNameValid: payload.valid };
    case CHECK_TEMPLATE_NAME_FAILED:
      return { ...state, templateNameValid: false };

    case RESET_TEMPLATE_NAME_VALID:
      return {
        ...state,
        templateNameValid: undefined,
      };
    case SET_SEARCH_TEMPLATES:
      return {
        ...state,
        search: payload,
      };
    case SEARCH_TEMPLATES:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case SEARCH_TEMPLATES_SUCCESS:
    case SEARCH_TEMPLATEDRAFTS_SUCCESS:
      return {
        ...state,
        loading: false,
        templates: payload,
      };
    case SEARCH_TEMPLATEDRAFTS:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_TEMPLATE_DETAILS_FAILED:
    case FETCH_TEMPLATEDRAFT_DETAILS_FAILED:
    case FETCH_LIVERANGETEMPLATE_DETAILS_FAILED:
    case SEARCH_TEMPLATES_FAILED:
    case SEARCH_TEMPLATEDRAFTS_FAILED:
    case REMOVE_TEMPLATES_FAILED:
    case REMOVE_TEMPLATEDRAFTS_FAILED:
    case RENAME_TEMPLATE_FAILED:
    case PUBLISH_DRAFT_FAILED:
      return {
        ...state,
        loading: false,
        removeLoading: false,
        detailsLoading: false,
        error: payload,
      };
    case SET_SORT_CRITERIAS:
      return {
        ...state,
        sorting: payload,
      };
    case SET_EXAM_TYPES:
      return {
        ...state,
        examTypes: Array.isArray(payload)
          ? payload.map((item) =>
              typeof item === 'string' ? item : item.ExamType || item.examType || item.name || item.value || ''
            )
          : [],
      };
    case FETCH_TEMPLATE_DETAILS:
      return {
        ...state,
        detailsLoading: true,
      };
    case FETCH_TEMPLATE_DETAILS_SUCCESS:
      return {
        ...state,
        detailsLoading: false,
        templateDetails: payload,
      };
    case FETCH_LIVERANGETEMPLATE_DETAILS:
      return {
        ...state,
        detailsLoading: true,
      };
    case FETCH_LIVERANGETEMPLATE_DETAILS_SUCCESS:
      return {
        ...state,
        detailsLoading: false,
        templateDetails: payload,
      };
    case FETCH_TEMPLATEDRAFT_DETAILS:
      return {
        ...state,
        detailsLoading: true,
      };
    case FETCH_TEMPLATEDRAFT_DETAILS_SUCCESS:
      return {
        ...state,
        detailsLoading: false,
        templateDetails: payload,
      };
    case SET_EDITED_EXAM:
      return {
        ...state,
        editedExam: payload,
      };
    case SET_ADDED_EXAM:
      return {
        ...state,
        addedExam: payload,
      };
    case REMOVE_TEMPLATES:
      return {
        ...state,
        removeLoading: true,
      };
    case REMOVE_TEMPLATES_SUCCESS:
      return {
        ...state,
        removeLoading: false,
      };
    case REMOVE_TEMPLATEDRAFTS:
      return {
        ...state,
        removeLoading: true,
      };
    case REMOVE_TEMPLATEDRAFTS_SUCCESS:
      return {
        ...state,
        removeLoading: false,
      };
    case RENAME_TEMPLATE:
      return {
        ...state,
        detailsLoading: true,
      };
    case RENAME_TEMPLATE_SUCCESS:
      return {
        ...state,
        templateDetails: { ...state.templateDetails, templateName: payload },
        detailsLoading: false,
      };
    case IMPORT_FILE: {
      return {
        ...state,
        importLoading: true,
      };
    }
    case IMPORT_FILE_SUCCESS: {
      return {
        ...state,
        importLoading: false,
        importFailed: false,
        importValidationData: payload,
        totalCount: totalCount,
        validationErrors: validationErrors,
      };
    }
    case IMPORT_FILE_FAILED: {
      return {
        ...state,
        importLoading: false,
        importFailed: true,
        resourceFileUploadResponse: payload,
      };
    }
    case 'UPDATE_TEMPLATE_DETAILS': {
      // If payload.examsConfiguration contains an examId that matches an existing slot, update that slot
      let updatedExamsConfiguration = payload.examsConfiguration;
      if (Array.isArray(updatedExamsConfiguration) && state.templateDetails?.examsConfiguration) {
        updatedExamsConfiguration = updatedExamsConfiguration.map((exam) => {
          const existing = state.templateDetails.examsConfiguration.find((e) => e.examId === exam.examId);
          return existing ? { ...existing, ...exam } : exam;
        });
      }
      return {
        ...state,
        templateDetails: {
          ...state.templateDetails,
          ...payload,
          examsConfiguration: updatedExamsConfiguration, // always use the new array
          examsNameCount: payload.examsNameCount, // always use the new array
        },
      };
    }
    case UPDATE_VALIDATED_IMPORT: {
      return {
        ...state,
        importLoading: true,
      };
    }
    case UPDATE_VALIDATED_IMPORT_SUCCESS: {
      return {
        ...state,
        successErrorReport: payload,
      };
    }
    case UPDATE_VALIDATED_IMPORT_FAILED: {
      return {
        ...state,
        importLoading: false,
      };
    }
    case CREATE_TEMPLATE_DETAILS:
      return {
        ...state,
        createLoading: true,
      };
    case CREATE_TEMPLATE_DETAILS_SUCCESS:
      return {
        ...state,
        createLoading: false,
        templateDetails: payload,
      };
    case CREATE_TEMPLATE_DETAILS_FAILED:
      return {
        ...state,
        createLoading: false,
      };
    case CREATE_TEMPLATEDRAFT_DETAILS:
      return {
        ...state,
        createLoading: true,
      };
    case CREATE_TEMPLATEDRAFT_DETAILS_SUCCESS:
      return {
        ...state,
        createLoading: false,
        templateDetails: payload,
      };
    case CREATE_TEMPLATEDRAFT_DETAILS_FAILED:
      return {
        ...state,
        createLoading: false,
      };
    case CLEAN_IMPORT_LAYOUT: {
      return {
        ...state,
        importLoading: false,
        importFailed: false,
        importValidationData: [],
        successErrorReport: {},
        totalCount: null,
        validationErrors: [],
      };
    }
    case UNMAP_OFFICE: {
      return {
        ...state,
      };
    }
    case UNMAP_OFFICE_SUCCESS: {
      return {
        ...state,
      };
    }

    case UNMAP_OFFICE_FAILED: {
      return {
        ...state,
      };
    }

    case SET_CAN_ADD_EXAM:
      return { ...state, canAddExam: payload };
    case CLONE_TEMPLATE_DETAILS:
      return {
        ...state,
        cloneSuccess: false,
      };
    case CLONE_TEMPLATE_DETAILS_SUCCESS:
      return {
        ...state,
        cloneSuccess: payload,
      };
    case RESET_CLONE_SUCCESS:
      return {
        ...state,
        cloneSuccess: false,
      };
    case UPDATE_TEMPLATEDRAFT_SLOT_DETAILS:
      return {
        ...state,
        saveSuccess: false,
      };
    case UPDATE_TEMPLATEDRAFT_SLOT_DETAILS_SUCCESS:
      return {
        ...state,
        saveSuccess: payload,
      };
    case PUBLISH_DRAFT:
      return {
        ...state,
        saveSuccess: false,
      };
    case PUBLISH_DRAFT_SUCCESS:
      return {
        ...state,
        saveSuccess: payload,
      };
    case UPDATE_TEMPLATE_SLOT_DETAILS:
      return {
        ...state,
        saveSuccess: false,
      };
    case UPDATE_TEMPLATE_SLOT_DETAILS_SUCCESS:
      return {
        ...state,
        saveSuccess: payload,
      };
    case UPDATE_LIVE_SPECIALRANGE_TEMPLATE_SLOT_DETAILS:
      return {
        ...state,
        saveSuccess: false,
      };
    case UPDATE_LIVE_SPECIALRANGE_TEMPLATE_SLOT_DETAILS_SUCCESS:
      return {
        ...state,
        saveSuccess: payload,
      };
    case UPDATE_LIVE_SPECIALRANGE_TEMPLATE_SLOT_DETAILS_FAILED:
      return {
        ...state,
        createLoading: false,
        loading: false,
      };
    case UPDATE_LIVE_RANGE0_TEMPLATE_SLOT_DETAILS:
      return {
        ...state,
        saveSuccess: false,
      };
    case UPDATE_LIVE_RANGE0_TEMPLATE_SLOT_DETAILS_SUCCESS:
      return {
        ...state,
        saveSuccess: payload,
      };
    case UPDATE_LIVE_RANGE0_TEMPLATE_SLOT_DETAILS_FAILED:
      return {
        ...state,
        createLoading: false,
        loading: false,
      };
    case SET_SELECTED_HOO:
      return {
        ...state,
        selectedHoo: payload,
      };
    case REMOVE_SLOT_FROM_SESSION: {
      // Remove the slot from templateDetails.examsConfiguration by examId
      if (!state.templateDetails || !state.templateDetails.examsConfiguration) return state;
      // find the slot being removed so we can store it
      const toRemove = state.templateDetails.examsConfiguration.find((exam) => exam.examId === payload.examId);
      const updatedExamsConfiguration = state.templateDetails.examsConfiguration.filter(
        (exam) => exam.examId !== payload.examId
      );

      return {
        ...state,
        toberemoved: toRemove ?? null, // save removed slot detail
        templateDetails: {
          ...state.templateDetails,
          examsConfiguration: updatedExamsConfiguration,
          examsNameCount: state.templateDetails.examsNameCount,
        },
      };
    }
    default:
      return state;
  }
};
